import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  colspan: "3",
  class: "border border-next-gray-md-dark p-2 font-bold"
}
const _hoisted_4 = { class: "pb-3" }
const _hoisted_5 = { class: "border border-next-gray-md-dark align-top" }
const _hoisted_6 = { class: "pl-2" }
const _hoisted_7 = { class: "border border-next-gray-md-dark align-top" }
const _hoisted_8 = { class: "list-disc pl-5" }
const _hoisted_9 = { class: "border border-next-gray-md-dark align-top" }
const _hoisted_10 = { class: "list-disc pl-5" }
const _hoisted_11 = { class: "border border-next-gray-md-dark align-top" }
const _hoisted_12 = { class: "list-disc pl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Paginator, {
      pagination: _ctx.listaSottoprogettiProgetto.paginate
    }, null, 8, ["pagination"]),
    _createElementVNode("table", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th"),
          _createElementVNode("th"),
          _createElementVNode("th")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaSottoprogettiProgetto.rows, (s) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, "Data storico: " + _toDisplayString(_ctx.$filters.toDate(s.data)), 1)
            ]),
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("td", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "font-bold p-2" }, "Utente della modifica", -1)),
                _createElementVNode("p", _hoisted_6, _toDisplayString(s.created_by?.name || '---'), 1)
              ]),
              _createElementVNode("td", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "font-bold p-2" }, "Responsabile", -1)),
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", null, _toDisplayString(s.responsabile?.name || 'vuoto'), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_9, [
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "font-bold p-2" }, "Presentazione", -1)),
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.presentazioni, (r) => {
                    return (_openBlock(), _createElementBlock("li", null, _toDisplayString(r.name), 1))
                  }), 256))
                ])
              ]),
              _createElementVNode("td", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "font-bold p-2" }, "Account", -1)),
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.accounts, (r) => {
                    return (_openBlock(), _createElementBlock("li", null, _toDisplayString(r.name), 1))
                  }), 256))
                ])
              ])
            ])
          ], 64))
        }), 256))
      ])
    ]),
    _createVNode(_component_InfiniteLoading, {
      onInfinite: _ctx.listaSottoprogettiProgetto.fetchNextPage,
      identifier: _ctx.listaSottoprogettiProgetto.infiniteIdentifier,
      style: {"min-height":"1px"}
    }, {
      complete: _withCtx(() => _cache[5] || (_cache[5] = [
        _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre righe di storico.", -1)
      ])),
      _: 1
    }, 8, ["onInfinite", "identifier"])
  ]))
}